import { jsx } from "react/jsx-runtime";
import { ModalTrigger, Anchor } from "@zillow/constellation-10";
import { uniq } from "lodash";
import { useContext } from "react";
import BlocksContext from "../components/BlockList/BlockContext.esm.js";
import { usePopulateParamPlaceHolders } from "./populateParamPlaceholders.esm.js";
function getBlockById(blocks, id) {
  let object;
  blocks.some(function iter(block) {
    var _a;
    if (((_a = block == null ? void 0 : block.attrs) == null ? void 0 : _a.id) === id) {
      object = block;
      return true;
    }
    return Array.isArray(block.innerBlocks) && block.innerBlocks.some(iter);
  });
  return object;
}
const isValidTrigger = (target) => /#(.*)/gm.test(target);
function withTrigger(WrapperComponent) {
  return function WithTrigger(props) {
    const {
      triggerLink,
      onClick,
      ...rest
    } = props;
    const {
      rootBlocks
    } = useContext(BlocksContext);
    if (!rootBlocks) {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...{
        ...rest,
        onClick
      } });
    }
    if (!triggerLink || !isValidTrigger(triggerLink)) {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...{
        ...rest,
        onClick
      } });
    }
    const triggerDetails = getBlockById(rootBlocks, triggerLink.substring(1));
    if (!triggerDetails || (triggerDetails == null ? void 0 : triggerDetails.blockName) !== "constellation/modal-dialog") {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...{
        ...rest,
        onClick
      } });
    }
    const modalId = triggerLink.substring(1);
    return /* @__PURE__ */ jsx(ModalTrigger, { multiModalTriggerId: modalId, children: /* @__PURE__ */ jsx(WrapperComponent, { ...rest, onClick: (e) => {
      e.preventDefault();
      onClick == null ? void 0 : onClick(e);
    } }) });
  };
}
const AnchorWithTrigger = withTrigger(Anchor);
function withAnchor(WrapperComponent) {
  const WithAnchorComponent = (props) => {
    const {
      link
    } = props.attrs;
    const href = usePopulateParamPlaceHolders(link == null ? void 0 : link.url);
    if (link == null ? void 0 : link.url) {
      const rel = [];
      if (link.sponsored) {
        rel.push("nofollow");
        rel.push("sponsored");
      }
      if (link.nofollow) {
        rel.push("nofollow");
      }
      return /* @__PURE__ */ jsx(AnchorWithTrigger, { triggerLink: href, href, rel: rel.length > 0 ? uniq(rel).join(" ") : void 0, target: link.opensInNewTab ? "_blank" : void 0, children: /* @__PURE__ */ jsx(WrapperComponent, { ...props }) });
    }
    return /* @__PURE__ */ jsx(WrapperComponent, { ...props });
  };
  return WithAnchorComponent;
}
export {
  getBlockById,
  isValidTrigger,
  withAnchor,
  withTrigger
};
